import { ApiError } from '../api/client';

// The client already normalizes ApiError messages to user-safe text (5xx never
// leaks). Anything that isn't an ApiError (network failure, unexpected) gets a
// generic fallback so internals never surface.
export function errorMessage(err: unknown, fallback = 'Something went wrong. Please try again.'): string {
  if (err instanceof ApiError) return err.message;
  return fallback;
}

export function isEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
}
